module.exports = __webpack_public_path__ + "static/media/phone.d9285d7e.svg";